export default {
  state: {
    user_addresses: [],
    qr_id: null,
    qrInfo: null,
    qr_type: null,
    loginDialog: false,
    identifier: "",
    domain: "",
    change: false,
  },
  getters: {},
  actions: {
    updateQrId({ commit }, input) {
      commit("update_qr_id", input);
    },
    updateAddress({ commit }, input) {
      let id = input.find((item) => !!item.default);
      if (!!id) commit("cart/update_checkout_address", id.id, { root: true });
      commit("update_address", input);
    },
    updateQrInfo({ commit }, input) {
      commit("update_qr_info", input);
    },
    handleLoginPopup({ commit }, input) {
      commit("update_login_popup", input);
    },
    updateQrType({ commit }, input) {
      commit("update_qr_type", input);
    },
    updateQridentifier({ commit }, input) {
      commit("update_qr_identifier", input);
    },
    updateQrDomain({ commit }, input) {
      commit("update_qr_domain", input);
    },
    updateQrInfoChange({ commit }, input) {
      commit("update_qr_info_change", input);
    },
  },
  mutations: {
    update_address(state, input) {
      state.user_addresses = input.map((item) => {
        return {
          ...item,
          address_id: item.id,
        };
      });
    },
    update_qr_id(state, input) {
      state.qr_id = input;
    },
    update_qr_info(state, input) {
      state.qrInfo = input;
    },
    update_login_popup(state, input) {
      state.loginDialog = input;
    },
    update_qr_type(state, input) {
      state.qr_type = input;
    },
    update_qr_identifier(state, input) {
      state.identifier = input;
    },
    update_qr_domain(state, input) {
      state.domain = input;
    },
    update_qr_info_change(state, input) {
      state.change = !state.change;
    },
  },
  namespaced: true,
};
